import React, { Suspense, useEffect, useRef } from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Router,
  Routes,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import {
  homepageURL,
  blogListPageURL,
  blogDetailsPageURL,
  contactusPageURL,
  loanPageURL,
  getQuotePageURL,
  getQuotePageJaipurURL,
  getQuotesInJaipurURL,
  getQuotesInMumbaiURL,
  getQuotesInDelhiURL,
  getQuotesInNoidaURL,
  getQuotesInFaridabadURL,
  getQuotesInGhaziabadURL,
  getQuotesInGurgaonURL,
  getQuotesInAlwarURL,
  getQuotesInPalwalURL,
  getQuotesInPushkarURL,
  getQuotesForDestinationURL,
  getQuotesForDestinationRajasthanURL,
  getQuotesDestinationInJaipurURL,
  perfectCorporateEventVenuesDelhiNcrURL,
  perfectCorporateEventVenuesGurgaonNcrURL,
} from "./constants/path_constants";

import "./App.css";
import Navbar from "./components/navbar/Navbar";
import HomePage from "./pages/home/HomePage";
import FullPageLoader from "./pages/loader/FullPageLoader";
import BlogListingPage from "./pages/blogpage/BlogListPage";
import BlogDetailsPage from "./pages/blog-details/BlogDetailsPage";
import Footer from "./components/footer/Footer";
import ContactUsWrapper from "./pages/ContactUsForm/ContactUsWrapper";
import LoanLandingPage from "./pages/loanPage/LoanLandingPage";
import GetQuotePage from "./pages/get-quote/GetQuotePage";
import GetQuotePageJaipur from "./pages/get-quote/GetQuotePageJaipur";
import GetQuotePageMumbai from "./pages/get-quote/GetQuotePageMumbai";
import GetQuotePageDelhi from "./pages/get-quote/GetQuotePageDelhi";
import GetQuotePageNoida from "./pages/get-quote/GetQuotePageNoida";
import GetQuotePageFaridabad from "./pages/get-quote/GetQuotePageFaridabad";
import GetQuotePageGhaziabad from "./pages/get-quote/GetQuotePageGhaziabad";
import GetQuotePageGurgaon from "./pages/get-quote/GetQuotePageGurgaon";
import GetQuotePageAlwar from "./pages/get-quote/GetQuotePageAlwar";
import GetQuotePagePalwal from "./pages/get-quote/GetQuotePagePalwal";
import GetQuotePagePushkar from "./pages/get-quote/GetQuotePagePushkar";
import GetQuotePageDestination from "./pages/get-quote/GetQuotePageDestination";
import GetQuotePageDestinationRajasthan from "./pages/get-quote/GetQuotePageDestinationRajasthan";
import GetQuotePageDestinationJaipur from "./pages/get-quote/GetQuotePageDestinationJaipur";
import GetQuotePageCorporateDelhiNcr from "./pages/get-quote/GetQuotePageCorporateDelhiNcr";
import GetQuotePageCorporateGurgaonNcr from "./pages/get-quote/GetQuotePageCorporateGurgaonNcr";
import { useDispatch, useSelector } from "react-redux";
import { consumeMagicToken } from "./Redux/Action/AppAction";
import { getSelectedEvent, getUser } from "./Redux/Reducer/AppReducer";
import GoogleAnalyticsRouteListener from "./components/analytics/GoogleAnalyticsRouteListener";
import NoInternet from "./components/NoInternet/NoInternet";
import NotFoundPage from "./pages/NotFound/NotFoundPage";

function App() {
  let [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const dispatch = useDispatch()
  const event = useSelector(getSelectedEvent);
  const user = useSelector(getUser)


  console.log(user,event,"conspsoso")

  const scrollToSection = (url) => {
    const hash = url.split("#")[1]; 
    const section = document.getElementById(hash);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

// useEffect(()=>{
//   let mgk = searchParams.get("mgk")
//   if (
//     mgk !== '' &&
//     mgk !== 'undefined' &&
//     mgk !== undefined
// ) {
//     dispatch(consumeMagicToken(mgk));
// }
// },[])




  useEffect(() => {
    window.scrollTo(0, 0);
   
    if (location.hash) {
      scrollToSection(location.hash);
    }
  }, [location.hash]); 

  const NotAuthenticatedRoutes = () => {

    return (
      <Routes>
        <Route path={homepageURL} element={<HomePage />} />
        <Route path={loanPageURL} element={<LoanLandingPage />} />
        <Route path={blogListPageURL} element={<BlogListingPage />} />
        <Route path={contactusPageURL} element={<ContactUsWrapper />} />
        <Route path={getQuotePageURL} element={<GetQuotePage />} />
        <Route path={getQuotesInJaipurURL} element={<GetQuotePageJaipur />} />
        <Route path={getQuotesInMumbaiURL} element={<GetQuotePageMumbai />} />
        <Route path={getQuotesInDelhiURL} element={<GetQuotePageDelhi />} />
        <Route path={getQuotesInNoidaURL} element={<GetQuotePageNoida />} />
        <Route path={getQuotesInFaridabadURL} element={<GetQuotePageFaridabad />} />
        <Route path={getQuotesInGhaziabadURL} element={<GetQuotePageGhaziabad />} />
        <Route path={getQuotesInGurgaonURL} element={<GetQuotePageGurgaon />} />
        <Route path={getQuotesInAlwarURL} element={<GetQuotePageAlwar />} />
        <Route path={getQuotesInPalwalURL} element={<GetQuotePagePalwal />} />
        <Route path={getQuotesInPushkarURL} element={<GetQuotePagePushkar />} />
        <Route path={getQuotesForDestinationURL} element={<GetQuotePageDestination />} />
        <Route
          path={getQuotesForDestinationRajasthanURL}
          element={<GetQuotePageDestinationRajasthan />}
        />
        <Route
          path={getQuotesDestinationInJaipurURL}
          element={<GetQuotePageDestinationJaipur />}
        />
                  <Route
            path={perfectCorporateEventVenuesDelhiNcrURL}
            element={<GetQuotePageCorporateDelhiNcr />}
          />
          <Route
            path={perfectCorporateEventVenuesGurgaonNcrURL}
            element={<GetQuotePageCorporateGurgaonNcr />}
          />
        <Route path={blogDetailsPageURL} element={<BlogDetailsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    );
  };

  const getRoutes = () => {
    return <NotAuthenticatedRoutes />;
  };

  return (
    <div className="app-shell">
      <NoInternet />
      <GoogleAnalyticsRouteListener />
      <Navbar />
      <main className="app-main">
        <div className="app-route-outlet">
          <Suspense fallback={<FullPageLoader />}>{getRoutes()}</Suspense>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default App;
